import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const Welcome = () => import("@/views/pages/Welcome");
const Logs = () => import("@/views/pages/logs/Index");
const BranchKeyword = () => import("@/views/pages/branch-keyword/Index");
const BranchDetail = () => import("@/views/pages/branch-keyword/Details");

const ProductKeyword = () => import("@/views/pages/product-keyword/Index");
const ProductDetail = () => import("@/views/pages/product-keyword/Details");

const FormatKeyword = () => import("@/views/pages/format-keyword/Index");
const FormatDetail = () => import("@/views/pages/format-keyword/Details");

const PromptTemplate = () => import("@/views/pages/prompt-template/Index");
const PromptTemplateDetail = () => import("@/views/pages/prompt-template/Details");

const CheckPredict = () => import("@/views/pages/CheckPredict");
const DetectOCR = () => import("@/views/pages/DetectOCR");
const Prediction = () => import("@/views/pages/prediction/Index");
// const User = () => import("@/views/pages/user/Index");
// const UserDetail = () => import("@/views/pages/user/Details");
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
// const Login = () => import("@/views/pages/Login");

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    // {
    //   path: "/login",
    //   name: "Login",
    //   component: Login,
    //   meta: { requiresIsLogin: true },
    // },
    {
      path: "/",
      redirect: "/",
      name: "HOME",
      component: TheContainer,
      // meta: { requiresAuth: true },
      children: [
        {
          path: "/",
          name: "Welcome",
          component: Welcome,
          // meta: { requiresAuth: true }
        },
        {
          path: "/logs",
          name: "LOGS LIST",
          component: Logs,
          // meta: { requiresAuth: true }
        },
        {
          path: "/Branch-Keyword",
          name: "Branch Keyword",
          component: BranchKeyword,
          // meta: { requiresAuth: true }
        },
        {
          path: "/Branch-Keyword/details/:id",
          name: "ข้อมูล Branch Keyword",
          component: BranchDetail,
          // meta: { requiresAuth: true }
        },

        {
          path: "/Product-Keyword",
          name: "Product Keyword",
          component: ProductKeyword,
          // meta: { requiresAuth: true }
        },
        {
          path: "/Product-Keyword/details/:id",
          name: "ข้อมูล Product Keyword",
          component: ProductDetail,
          // meta: { requiresAuth: true }
        },
        
        {
          path: "/Format-Keyword",
          name: "Format Keyword",
          component: FormatKeyword,
          // meta: { requiresAuth: true }
        },
        {
          path: "/Format-Keyword/details/:id",
          name: "ข้อมูล Format Keyword",
          component: FormatDetail,
          // meta: { requiresAuth: true }
        },

        {
          path: "/Prompt-Template",
          name: "Prompt Template",
          component: PromptTemplate,
          // meta: { requiresAuth: true }
        },
        {
          path: "/Prompt-Template/details/:id",
          name: "ข้อมูล Prompt Template",
          component: PromptTemplateDetail,
          // meta: { requiresAuth: true }
        },


        {
          path: "/CheckPredict",
          name: "ข้อมูล Check Predict",
          component: CheckPredict,
          // meta: { requiresAuth: true }
        },
        {
          path: "/DetectOCR",
          name: "Detect OCR",
          component: DetectOCR,
          // meta: { requiresAuth: true }
        },
        {
          path: "/prediction",
          name: "Prediction",
          component: Prediction,
          meta: { requiresAuth: true }
        },
        // {
        //   path: "/user",
        //   name: "USER LIST",
        //   component: User,
        //   meta: { requiresAuth: true },
        // },
        // {
        //   path: "/user/details/:id",
        //   name: "ข้อมูล USER ID",
        //   component: UserDetail,
        //   meta: { requiresAuth: true },
        // },
        {
          path: "404",
          name: "Page404",
          component: Page404
        },
        {
          path: "500",
          name: "Page500",
          component: Page500
        }
      ]
    }
  ]
});
